import React, { useState } from 'react';
import { ReactComponent as ImageIcon } from '../../../assets/icons/image-1.svg';
import { ReactComponent as FolderIcon } from '../../../assets/icons/folder.svg';
import { ReactComponent as FolderLockIcon } from '../../../assets/icons/folder-lock.svg';
import { ReactComponent as BoxIcon } from '../../../assets/icons/box.svg';
import { ButtonContainer, FooterButton, Row, TooltipContainer } from './UploadChatMediaButton.styles';
import { Text14Bold } from '../../utils/Text/Text.styles';
import { MEDIA_ASSET_SALE_TAG } from '../../../utils/constants';

const UploadChatMediaButton = ({ onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <ButtonContainer>
      <FooterButton type="button" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
        <ImageIcon color="#1672BA" />
      </FooterButton>
      {showTooltip && (
        <TooltipContainer onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
          <Row onClick={() => onClick([MEDIA_ASSET_SALE_TAG.SINGLE_FREE])} $borderBottom>
            <FolderIcon />
            <Text14Bold>Free Media</Text14Bold>
          </Row>
          <Row onClick={() => onClick([MEDIA_ASSET_SALE_TAG.SINGLE_PAID])} $borderBottom>
            <FolderLockIcon />
            <Text14Bold>Paid Media</Text14Bold>
          </Row>
          <Row onClick={() => onClick(MEDIA_ASSET_SALE_TAG.BUNDLE)}>
            <BoxIcon />
            <Text14Bold>Bundle</Text14Bold>
          </Row>
        </TooltipContainer>
      )}
    </ButtonContainer>
  );
};

export default UploadChatMediaButton;
